// extracted by css-extract-rspack-plugin
export default {"cls1":"WinBackPing-cls1_NeA","cls2":"WinBackPing-cls2_2vm WinBackPing-cls1_NeA"};